import React, { useState, useRef } from "react";

import MessageForm from "./MessageForm";
import FinalMessage from "./FinalMessage";
import Icons from "../Icons/Icons";
import Empty from "../UI/Empty";

import styled from "./MessageComponent.module.css";

const MessageComponent = function () {
  const formRef = useRef();
  const [messageOpen, setMessageOpen] = useState(false);
  const [name, setName] = useState({ name: "", isValid: false });

  const submitHandler = function (e) {
    e.preventDefault();

    if (formRef.current.value.trim() === "") return;

    setName({
      name: formRef.current.value,
      isValid: true,
    });
  };

  const messageOpenHandler = function () {
    setMessageOpen(true);
  };

  return (
    <React.Fragment>
      <Empty>
        <Icons nameValid={name.isValid} onMessage={messageOpenHandler} />
        {name.isValid || (
          <section className={styled.main}>
            <MessageForm onSubmit={submitHandler} ref={formRef} />
          </section>
        )}
        {messageOpen && (
          <section className={styled.main}>
            <FinalMessage name={name.name} />
          </section>
        )}
      </Empty>
    </React.Fragment>
  );
};
export default MessageComponent;
